export const emtrConstant = {
  rulesConstant: {
    rulesHeader: 'Rules',
    addNewRule: 'Add New Rule',
    editRuleName: 'Edit Rule',
    viewRuleName: 'View Rule',
    ruleName: 'Rule Name',
    characterLimit: 'Char. Limit:',
    ruleType: 'Rule Type',
    individualSecurity: 'Individual Security',
    underlyingOptions: 'Underlying Options',
    underlyingDerivatives: 'Underlying Derivatives',
    securityType: 'Security Type',
    advancedSearchTxt: 'Advanced Search',
    appliesTo: 'Applies To',
    selectDates: 'Select Date(s)',
    descriptionNotesTitle: 'Description and Notes',
    ruleAssign: 'Rule Assigned to',
    fromToDateTimeCheck: (30 * 60 * 1000),
    pleaseCorrectFollowingError: 'Please correct following error.',
    securityModalMaxLimitError: 'The maximum number of results has been Reached:',
    ruleHistory: 'Rule History',
    maxSecurityCount: 2000,
    ruleNameLbl: 'Rule Name',
    subTypeLbl: 'Sub Type',
    startDate: 'Start Date',
    endDate: 'End Date',
    expiredCapsTxt: 'EXPIRED',
    editCapsTxt: 'EDIT',
    ruleActiveStatus: 'ACTIVE',
    ruleDraftStatus: 'DRAFT',
    globalRuleLbl: 'Global Rule',
    changeRequestId: 'Change Request ID',
    globalObj: { bu: 'RBS', orgIds: [], type: 'GLOBAL'},
    semiGlobalObj: { bu: 'RBS', orgIds: [], type: 'SEMI_GLOBAL'},
    autoComplete: {
      placeholder: 'Search Securities',
      fundFamilySearchPlaceHolder: 'Search Fund Families',
      noRecords: 'No Records Found',
      FNDISUTxt: 'FNDFMLY',
      RESTRICT_LST_ENGTxt: 'RESTRICT_LST_ENG',
      duplicateRecord: 'Security is already added into the list',
      searchAndSelectSecurityTo: 'Search and Select Securities to',
      searchAndSelectSecurity: 'Search and Select Securities',
      selectFundFamiliesToRestrict: 'Select Fund Families to',
      fundFamilesRestrictTxt: 'Select Fund Families to Restrict',
      fundFamilesOverrideTxt: 'Select Fund Families to Override',
      securityInstrumentGrpRestrictText: 'Select Securities/Instrument Groups to Restrict',
      selectedSecOrInstGrpRestrictText: 'Selected Securities/Instrument Groups to Restrict',
      selectFundFamiliesToRestrictTxt: 'Selected Fund Families to Restrict',
      searchFundFamiliesToRestrict: 'Search and Select Fund Families to',
      noSecuritiesSelectedTo: 'No Securities Selected. Please Search and Select Securities to',
      noSecuritiesSelected: 'No Securities Selected. Please Search and Select Securities',
      noFundFamiliesSelected: 'No Fund Families Selected. Please Search and Select Fund Families to',
      securitySelected: 'Security selected:',
      fundFamilySelected: 'Fund Family Selected',
      instrumentGroupPlaceholder: 'Search Instrument Groups',
      instrumentGroupToRestrict: 'Search and Select Instrument Groups to Restrict',
      instrumentGroupToOverride: 'Search and Select Instrument Groups to Override',
      noInstrumentGroupsSelected: 'No Instrument Groups Selected. Please Search and Select Instrument Groups',
      instrumentGroupDuplicateRecord: 'Instrument Group is already added into the list',
      noSecuritySelected: 'No Securities Selected.',
      noInstrumentGroupSelected: 'No Instrument Groups Selected.',
      downloadTempValue: 'SEC',
      securityTempFileName: 'EMTR_Security_Bulk_Upload_Template',
      invalidFileFormatError: 'File Type must be .CSV! Please select the correct format and try again.',
      uploadFailedError: 'File failed to upload. Please check the Specifications tab of the template, make necessary changes, and upload again.',
      uploadSuccessMsg: 'File uploaded successfully. Available securities are shown in list below.',
      uploadMaxCountError: 'Only 300 securities can be uploaded at a time.',
      cusipText: 'cusip',
      tickerText: 'ticker',
      tickerSymbolText: 'ticker symbol',
      searchSecurityMustBeSelected: 'Security Type must be selected',
      exactTicker: 'Exact Ticker',
      exactMatchSymbol: 'SYMBOL_EXACTMATCH',
      exactMatchCusip: 'CUSIP_EXACTMATCH'

    },
    ruleNameMsg: {
      the: 'The ',
      ruleNameExistWarningMsg: ' Rule Name already exist. Please enter a unique name or click the Continue button to proceed with a duplicate Rule Name.',
      invalidCharacter: 'Invalid Character Entered - Please Use Valid Characters Only A-Z, a-z, 0-9, +,-,_,(,),[,], . (period) and , (comma).',
    },
    ruleGlobalConst: {
      recurrence: 'Recurrence',
      override: 'Override',
      restriction: 'Restriction',
      superRestriction: 'Super Restriction',
      watchList: 'Watchlist',
      fundFamily: 'Fund Family',
      delete: 'Delete',
      restore: 'Restore',
      cancel: 'Cancel',
      close: 'Close',
      copyAndUnassign: 'Copy & Unassign',
      unassign: 'Unassign',
      hideAcceptButton: 'hideAcceptButton',
      deleteSuccessMsg: 'rule has been deleted.',
      restoreSuccessMsg: 'rule has been restored.<br><p></p><strong>Note:</strong> Review the rule to ensure necessary assignments have been made.',
      bulkUploadTitle: 'Bulk Upload',
      bulkUploadRules: 'Bulk Upload - Rules',
      noCientSelected: 'Please Select a Client to Continue.',
      justification: 'Justification for Override  <span class="sdps-text-market-red">*</span>',
      copySuffixTxt: ' - Copy',
      viewSymboleInstGrpText: 'View Symbols',
      securityTypeRule: 'SECTYP',
      copyAndUnassignSuccessMsg: 'has been copied and unassigned from this plan.',
      unassignSuccessMsg: 'has been unassigned from this plan.',
      exportExcel: 'Export Excel'
    },
    rulesLanding: {
      copy: 'Copy',
      history: 'History',
      delete: 'Delete',
      cancel: 'Cancel',
      deleteMsgConfirmation: 'Are you sure you want to delete?',
      confirmationGlobalRuleHeader: 'Confirmation To Delete',
      deleteMsgConfirmationforGlobalRule:
        '<span class="globalrule-msg"> Note: Deleting the Global Rule will have a larger impact. ' +
        'Also note that deleting an <b>option-related Global Rule</b> may result in K4s no longer ' +
        'having option restrictions. Please verify the following before proceeding.</span>',
      deleteMsgConfirmationforOrphanSemiGlobalRule:'<span class="globalrule-msg"> Note: Deleting the Semi-Global Rule will have a larger impact. Please verify before deleting.</span>',
      deleteMsgConfirmationforSuperRule:'<span class="globalrule-msg"> Note: Deleting the Super Rule will have a larger impact. Please verify before deleting.</span>',
      deleteNotAssignedMsgConfirmation: 'is not currently assigned to any Restrictions.',
      instrumentGrpDeleteMsg: 'must be removed from the following assignment(s) before it can be deleted',
      hideAcceptButton: 'hideAcceptButton',
      deleteMsgHeader: 'Delete Semi Global Rule',
      deleteMsgConfirmationforSemiGlobalRule: 'There are Master Accounts currently assigned to the rule.' +'\n'+ 'Please remove assignments to proceed with deletion.',
      copyAndUnassignOBPRuleInfo: 'Copy & Unassign action will automatically create a copy of the rule and remove the default Open Brokerage restriction for this plan. Please verify that this change aligns with your compliance requirements before proceeding.',
      copyAndUnassignOBPRuleConfirmation: 'Are you sure you want to Copy & Unassign? If Yes, Please enter the Semi-Global Rule name to Copy & Unassign.',
      copyAndUnassignK4ConfirmationTitle: 'Confirmation To Copy & Unassign',
      unassignK4ConfirmationTitle: 'Confirmation To Unassign',
      unassignOBPRuleInfo: 'Unassign action will automatically remove the default Open Brokerage restriction for this plan. Please verify that this change aligns with your compliance requirements before proceeding.',
      unassignOBPRuleConfirmation: 'Are you sure you want to Unassign? If Yes, Please enter the Semi-Global Rule name to Unassign.',
    },
    ruleMessages: {
      ruleWaSuccessfullySavedAsDraft: ' rule was successfully saved as draft. ',
      continueByAssigningRule: 'Continue by assigning rule to All Employees, Employee Groups, Employee ID or Employee Account #',
      continueByAssigningRuleToMasterAcc: 'Continue by assigning rule to Master Groups and/or Master Accounts.',
      ruleWasSuccessfullySavedAndActivated: ' rule was successfully saved and activated',
      ruleChangesHaveBeenSavedAndUpdated: 'Rule Changes have been saved and updated',
      ruleWasSuccessfullySavedAndHasBeenScheduledToStart: ' rule was successfully saved and has been scheduled to start ',
      ruleWasExpired: 'rule has Expired',
      ruleWasSuccessfullySaved: ' rule was successfully saved.',
      invalidRuleNameErrorMsg: 'Incorrect Global Rule Name was entered. Rule was not deleted.',
      invalidSemiGlobalRuleNameForCopyAndUnassignErrorMsg: 'Incorrect Semi-Global Rule Name was entered. Rule was not copied and unassigned.',
      invalidSemiGlobalRuleNameForUnassignErrorMsg: 'Incorrect Semi-Global Rule Name was entered. Rule was not unassigned.'
    },
    ruleTypeLabels: {
      ruleTypeTitle: 'Buys/Sells/Short Sells <span class="sdps-text-market-red">*</span>',
      ruleTypeFundFamilyTitle: 'Buys/Sells <span class="sdps-text-market-red">*</span>',
      WATCH_LST_ENG: 'Watch',
      sells: 'Sells',
      shortSells: 'Short Sells',
      buys: 'Buys',
      RESTRICT_LST_ENG: 'Restrict',
      Override: 'Allow',
      Override_Fund: 'Override',
      security_WATCH_LST_ENG: 'Select Securities to Watchlist',
      security_RESTRICT_LST_ENG: 'Select Securities to Restrict',
      security_Override: 'Select Securities to Override',
      securityInstrumentGrpOverrideText: 'Select Securities/Instrument Groups to Override',
      selectedSecOrInstGrpOverrideText: 'Selected Securities/Instrument Groups to Override',
      search_Securities: 'Search and',
      selectSecurity: 'Select Securities to ',
      selectedSecurity: 'Selected Securities to ',
      ruleAttributes: 'Rule Attributes',
      restrictBuysSells: 'Restrict Buys/Sells',
      selectSecuritiesWarning: 'No Security Types selected yet',
      goToTop: 'Go to top',
      shortSellInfo: 'Short Sell Securities Types ONLY apply to: ALL Level 1 Equity Security (EQ), Level 2 Exchange Trade Fund and Product (ETF and ETFP), and Level 2 Options (OPT).',
      securityInfoText: 'The maximum number of results has been reached ',
      instrumentGroups_WATCH_LST_ENG: 'Select Instrument Groups to Watchlist',
      instrumentGroups_RESTRICT_LST_ENG: 'Select Instrument Groups to Restrict',
      instrumentGroups_Override: 'Select Instrument Groups to Override',
      WATCH_LST_ENGText : 'WATCH_LST_ENG',
    },
    assetType: {
      bond: 'BOND',
      other: 'OTH'
    },
    timePicker: ['1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00', '5:30', '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00', '9:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30'],
    dateTimePicker: {
      endDateError: 'To Date should be greater than From Date',
      endtimeError: 'End Time should be 30min ahead of From Time',
      validTimeError: 'Enter a valid time',
      dateRangeError: 'Date range should be between one year.'
    },
    editRule: {
      overrideRulenameSuffixTxt: 'OVRD - ',
      restrictRulenameSuffixTxt: 'RSTR - ',
      overrideJustification: {
        justificaton10b5: '10b5-1',
        legalClearance: 'Legal Clearance',
        taxCOver: 'Tax Cover',
        marginSellout: 'Margin Sellout',
        other: 'Other'
      },
      editStep1ReviewRule: {
        securities: 'Securities',
        securitiesRestricted: ' Restricted',
        securitiesAllowed: ' Allowed',
        securitiesWatched: ' Watched'
      },
    },
    confirmationMessage: {
      cancelBtnClickMsg: 'Are you sure you want to Cancel? This will cancel your session and unsaved changes will be lost.',
      menuClickMsg: 'You are about to leave this page and unsaved changes will not be saved. Are you sure you want to leave and Cancel?',
      previousBtnClickMsg: 'Do you want to save your current changes?',
      // eslint-disable-next-line max-len
      deActivateMsg:'Deactivating a client should only be performed in the event of a termination or contract change. This deactivation will immediately disable Trade blocking for any remaining linked accounts. To proceed, please enter a Deactivation Reason into the box, with reference to any Case ID needed for future audit. <br><strong>Note:</strong> <span class="deactivation-warn-msg">Historical data and reports for this client can still be accessed for a limited time once deactivation is complete.</span>',
      // eslint-disable-next-line max-len
      deactivateAddlinkMsg: 'Deactivating a client should only be performed in the event of a termination or contract change. This deactivation will immediately disable the ability to submit new Link or Delink requests through this system. To proceed, please enter a Deactivation Reason into the box, with reference to any Case ID needed for future audit. <br><strong>Note:</strong> <span class="deactivation-warn-msg">Historical data and reports for this client can still be accessed for a limited time once deactivation is complete.</span>',
      reActivateMsg:'Reactivating a client should only be performed in the event of a contract change. This reactivation will immediately enable Trade blocking for any remaining linked accounts. Would you like to proceed?'
    },
    reviewRuleMsg: {
      activateWarmingMsg: 'Must Activate the rule in order to take the new rule into effect',
      ruleIsCurrently: ' rule is currently ',
      anyUpdatesMustBeSaved: '. Any updates must be saved.',
      expiredRuleWarningMsg: '. No changes are allowed for expired rules.',
      missingFieldWarningMsg: 'The rule is missing required fields. Return to previous steps and fill out the required fields to proceed.',
      missingFieldWarningMsgforSemiGlobalRule: 'This Semi-Global rule currently has no assignments. Return to previous steps to provide missing information or choose "Cancel" or "Close" to delete it.'
    }
  },
  ruleSteps: {
    step2: {
      step2PresetRuleConditionText: 'presetRules',
      step2Restriction: 'Restriction Rule',
      step2Override: 'Override Rule',
      step2Recurrence: 'Set Recurrence',
      mutualFundsCode: 'mf',
      digitalAssetGroupCode: 'da',
      digitalAssetGroupText:'Digital Asset Group',
      operatingNetExpenseRatio: 'Operating / Gross Expense Ratio',
      operatingNetExpenseRatioCode: 'mfOpExpRatio',
      optionsAG: 'opt',
      spotCryptoCode: 'crypto',
      debtAGCode: 'g-schw-debt',
      nonCoveredOptCode:'optNonCvrdOpt',
      changeRequestIdInvalidMessage: 'Please Use Valid Characters Only A-Z, a-z, 0-9, - and space.',
      predefinedRestrictionsconfirmationMsg: 'The Predefined Restriction selected has been changed to Customized Asset Group since defining attributes of the Predefined Restriction have been removed. Do you want to Continue?',
      /* eslint-disable-next-line max-len */
      superSemiGlobalRuleInformationMsg: '<span class="globalrule-msg"> Note: Updating Global/Semi-Global Rules can have a large impact. Please verify the following before proceeding.</span>',
      /* eslint-disable-next-line max-len */
      informationMsg: '<span class="globalrule-msg"> Note: Updating Global/Semi-Global Rules can have a large impact. Also note that modifying restriction settings for <b>option-related Global/Semi-Global rules</b> may result in K4s no longer having option restrictions. Please verify the following before proceeding.</span>',
      superRuleInformationMsg: '<span class="globalrule-msg"> Note: Updating Super Rule will have a larger impact. Please verify the following before proceeding.</span>',
      modifyConfirmationMsg: 'Are you sure you want to edit this Global/Semi-Global Rule? If Yes, please enter the rule name to continue.',
      modifySuperRuleConfirmationMsg: 'Are you sure you want to edit this Super Rule? If Yes, please enter the rule name to continue.',
      violationConfirmationMsg: 'The Predefined Restrictions selected has been changed to Customized Asset Group since defining attributes of the Predefined Restriction have been removed. Do you want to continue? If Yes, Please enter the Global/Semi-Global Rule name to edit.',
      modify: 'Modify',
      noOptionsRestrictionErrorMsg: 'This rule could not be modified as this plan will no longer have any options restriction.'
    },
    step3: {
      clientsTab: 'Master Accounts',
      masterGrpTab: 'Master Groups',
      k4Text: 'K4',
      allClientInfo: {
        clientName: 'Business Unit',
        k4ClientName: 'Business Unit',
        orgId: 1,
        clientMasterAccounts: []
      }
    },
    step4: {
      reviewRule: 'Review Rule',
      ruleTypeTooltip: 'Rule Type and Sub Type fields are non-editable.',
      overrideJustification: {
        justificaton10b5: '10b5-1',
        legalClearance: 'Legal Clearance',
        taxCOver: 'Tax Cover',
        marginSellout: 'Margin Sellout',
        other: 'Other'
      },
      descTooltip: 'Please make the changes in text box itself.',
      overrideTooltip: 'Please make the changes in Step 4 itself.'
    }
  },
  multiselectText: 'Select Security Type',
  inValidDateMessage: 'Please enter a valid date MM/DD/YYYY',
  pastFromDateMessage: 'From Date should be Current or Future Date',
  pastToDateMessage: 'To Date should be Current or Future Date',
  invalidDate: 'Invalid Date',
  ruleFilter: {
    subType: [{value: 'All', label: 'All'}, {value: 'INDSEC', label: 'Individual Security'}, {value: 'SECTYP', label: 'Security Type'}, {value: 'FNDFMLY', label: 'Fund Family'}],
    ruleType: [{value: 'Restriction', label: 'Restriction'}, {value: 'Override', label: 'Override'}, {value: 'Watchlist', label: 'Watchlist'}],
    status: [{value: 'Active', label: 'Active'}, {value: 'Draft', label: 'Draft'}, {value: 'Expired', label: 'Expired'}, {value: 'Scheduled', label: 'Scheduled'}],
    clearButton: 'Clear',
    applyButton: 'Apply',
    ruleLevel: [{value: 'Client', label: 'Client'}, {value: 'Global', label: 'Global'}, {value: 'Semi-Global', label: 'Semi-Global'}],
    statusDefaultValue: ['Active', 'Draft', 'Scheduled']
  },
  rule10b5Msg: {
    planIdTxt: 'Plan ID',
    label10b5Txt: '10b5-1',
    restrictionCategoryTxt: 'Restriction Category',
    invalidCharacterEnteredNumericValue: 'Invalid Character Entered - Please enter numeric values 0-9',
    duplicateRuleName: 'Please enter a unique name or click the Continue button to proceed with a duplicate Rule Name',
    duplicateRuleNameAndPlanId: 'Please enter a unique plan id and click the Continue button to proceed with a duplicate Rule Name',
    duplicatePlanId: 'Rule must be created with a unique plan id',
    ruleNameNotExists: 'Rule name doesn\'t exist'
  },
  bulkUpload: {
    uploadTxt: 'Upload',
    downloadText: 'Download Rules Bulk Upload Template (Optional)',
    empDownloadTemplateTxt: 'Download Manage Employee Template',
    empGrpDownloadTemplateTxt: 'Download Manage Employee Groups Template',
    masterGrpDownloadTemplateTxt: 'Download Manage Master Groups Template',
    empBulkUploadTitleTxt: 'Bulk Upload - Manage Employees',
    bulkUploadManageEmployeeGroupTitle: 'Bulk Upload - Manage Employee Groups',
    masterGrpBulkUploadTitle: 'Bulk Upload - Manage Master Groups'
  },
  mangeEmployees: {
    editEmployeeTitle: 'Edit Employee',
    editEmployeeBlankMsg: {
      employeeIdMsg: 'Employee Id is a required field!',
      employeeFirstNameMsg: 'Employee first name is a required field!',
      employeeLastNameMsg: 'Employee last name is a required field!',
      employeeLastNameInvalidLengthMsg: 'Last name length is greater than 30!',
      employeeFirstNameInvalidLengthMsg: 'First name length is greater than 30!',
      employeeId: 'Employee ID',
      employeeFirstName: 'Employee First Name',
      employeeLastName: 'Employee Last Name',
      accountNumber: 'Account Number',
    },
  },
  manageEmployeeGroups: {
    manageEmployeeGroupsTitle: 'Manage Employee Groups',
    addNewEmpGrp: 'Add New Employee Group',
    deleteEmpGroupMessage: ' is assigned to following Rules and will no longer be applicable to the Employee Accounts that are part of this Employee Group.  Please review the Rule assignment to assure the rule is still applicable.',
    deleteEmpGroupSuccessMsg: 'Employee Group has been deleted.',
    employeeGroupAlreadyExist: ' Employee Group Name already exist. Please enter a unique Employee Group Name.',
    empGroupStep1: {
      enterGroupDetails: 'Enter Group Details',
      groupName: 'Group Name',
      groupDescription: 'Group Description'
    },
    empGroupStep2: {
      addEmployees: 'Add Employees',
      uploadEmployeeList: 'Upload Employee List',
      uploadMasterAccountList: 'Upload Master Account List',
    },
    empGroupStep3: {
      groupNameDescription: 'Group Name and Description',
      employees: 'Employees',
      reviewAndSave: 'Review and Save',
      addRemoveEmployees: 'Added / Removed Employees'
    },
    empGroup10b5Msg: {
      planIdTxt: 'Plan ID',
      empGrpExistTxt: 'employee group name already exists - please enter a unique employee group name',
      planIdExitsTxt: 'Employee group must be created with a unique plan id',
      bothNameAndPlanId: 'Employee group name already exists - please enter a unique employee group name with unique plan id'
    }
  },
  submitButton: 'Submit',
  manageMasterGroups: {
    masterGroupText: 'Manage Master Groups',
    masterGroupList: {
      addNewMasterGroup: 'Add New Master Group'
    }
  },
  exportTypes: {
    masterGroup: 'MasterGroupExport',
    instrumentGroup: 'InstrumentGroupExport'
  },
  restrictionSimulator: {
    restrictionSimulatorText: 'Restriction Simulator',
    accountNumberNotFoundMessage: 'Invalid Account Number',
    masterAccountsLabel: 'Master Account(s)',
    accountInformationTitle: 'Account Information',
    tradeOrdersTitle: 'Trade Orders',
    orderTypeFieldLabel: 'Order Type',
    securityTypeFieldLabel: 'Security Type',
    securitySearchLabel: 'Security search',
    securitySearchPlaceholder: 'Enter Ticker, Name, or CUSIP',
    selectedSecuritiesTableAriaLabel: 'Selected securities',
    tradeActionAriaLabel: 'Trade action',
    removeSecurityAriaLabel: 'Remove security',
    submitEligibilityWarningMessage: 'Submit is currently enabled for Standard Non-Options, Standard Options, and Thematic only.',
    requestSubmittedSuccessMessage: 'Restriction Simulator request submitted successfully.',
    requestFailedDefaultMessage: 'Restriction Simulator request failed. Please try again.',
    requestTimeoutMessage: 'Restriction Simulator request timed out. Please try again.',
    allowedValidationMessageTemplate: 'Trade is allowd, no restrictions',
    fixedIncomeSecurityTypeLabel: 'FI',
    restrictedValidationMessage: 'Trade is blocked due to active restrictions',
    domain: {
      orderType: {
        standard: 'Standard',
        thematic: 'Thematic'
      },
      securityType: {
        nonOptions: 'Non-Options',
        options: 'Options'
      },
      securitySearchType: {
        stock: 'STOCK',
        option: 'OPT'
      },
        restrictionSimulatorSearchSecurityType: {
        nonOptions: 'BOND,ETF,MF,STOCK'
      },
      action: {
        buy: 'Buy',
        sell: 'Sell',
        shortSell: 'Short Sell',
        buyToOpen: 'Buy to Open',
        buyToClose: 'Buy to Close',
        sellToOpen: 'Sell to Open',
        sellToClose: 'Sell to Close'
      }
    }
  },
  instrumentGroups: {
    instrumentGroupsText: 'Instrument Groups',
    instrumentGroupList: {
      addNewInstrumentGroup: 'Add New Instrument Group',
      toStep1: '/ems/emtr/instrument-groups/create-instrument-group/step1',
      toStep2: '../create-instrument-group/step2',
      toStep3: '../create-instrument-group/step3',
      toLandingPage: '/ems/emtr/instrument-groups/instrument-group-list',
      mainRoute: 'instrument-groups',
      instrumentGrpSaveMsg: 'Instrument Group was successfully saved.',
      instrumentGroupHistory: 'Instrument Group History'
    },
    instrumentGrpStep1: {
      addNewInstrumentGroupHeading: 'Add New Instrument Group',
      editInstrumentGroupHeading: 'Edit Instrument Group',
      viewInstrumentGroupHeading: 'View Instrument Group',
      businessUnit: 'Business Unit',
      groupNameExists: ' instrument group name already exists - please enter a unique instrument group name'
    },
    instrumentGrpStep2: {
      selectSecurities: 'Select Securities',
      selectInstruments: 'Select Securities',
      addedOrRemovedInstruments: 'Added / Removed Securities'
    },
    instrumentGrpDelete: {
      deleteInstrumentGroupMessage: ' is assigned to following Rule(s) and will no longer be applicable to the plans that are subject the Rule(s). Please review the Rule assignment to ensure the rule is still applicable.',
      instrumentGroupDeleteMsg: 'Instrument Group has been deleted.',
      instrumentGroupRestoreMsg: 'Instrument Group has been restored.<br><p></p><strong>Note:</strong> This does not automatically restore the Group to any rules that previously used it. Re-assignments will need to be made manually.'
    },
    instrumentGrpStep3:{
     securityTypeList: [{value: 'ETF', label: 'ETF'}, {value: 'EQ', label: 'EQ'}, {value: 'MF', label: 'Mutual Funds'},{value: 'OPT', label: 'Options'},{value: 'OTH', label: 'Others'}],
    }
  },

  presetRules: {
    presetRulesText: 'Predefined Restrictions',
    tradingMenu : 'Trading Menu',
    assetGroupText: 'Asset Group',
    assetGroupsAndAttributesText: 'Asset Groups & Attributes',
    miscellaneousAssetGroupText: 'Miscellaneous Asset Group',
    reviewSecTypeDetailsText: 'Review Security Type Details',
    customAssetGroupText: 'CUSTOM ASSET GROUP',
    etfLimitedPartnershipCode: 'etfLtdPship',
    eqLimitedPartnershipCode: 'eqLtdPship',
    exchangeTradedFunds: 'Exchange Traded Funds',
    limitedPartnership: 'Limited Partnerships',
    etfCode: 'etf',
    assetGrpWarningMsg: 'Please note that by selecting a category in the Asset Group section, this is no longer a Trading Menu.'
  },
  reviewSecurityType: {
    title: 'Review Security Type Details',
    subTitleRestriction: 'The following security types have been selected for restriction:',
    subTitleOverride: 'The following security types have been selected to be allowed:',
    emptyState: 'No security type selected.',
    close: 'Close',
    levelLabels: { SC1: 'Level 1', SC2: 'Level 2', SC3: 'Level 3' }
  },
  showRecords: [{value: true, label: 'Active'}, {value: false, label: 'Deleted'}]
};

export const DefaultValues = {
  defaultTableRecords: 15
};
